import { CloseCircleGreyIcon, Warning2Icon } from "assets";
import { ModalPortal, MODAL_LAYER } from "components/modal-portal";

interface ShortOnCreditModalProps {
  isOpen: boolean;
  onClose: () => void;
  creditBalance: number;
  creditsPerCV?: number;
  creditsRequired?: number;
  description?: string;
  onTopupCredit?: () => void;
}

/** Shown when the balance won't cover an action the user just tried to run. */
const ShortOnCreditModal = ({
  isOpen,
  onClose,
  creditBalance = 0,
  creditsPerCV = 5,
  creditsRequired,
  description,
  onTopupCredit,
}: ShortOnCreditModalProps) => {
  if (!isOpen) return null;

  return (
    <ModalPortal>
      <div className="fixed inset-0 flex items-center justify-center" style={{ zIndex: MODAL_LAYER.gate }}>
        {/* Backdrop */}
        <div className="absolute inset-0 bg-black/50" onClick={onClose} />

        {/* Modal */}
        <div className="relative bg-white rounded-2xl max-w-lg w-full mx-4 overflow-hidden">
          <button
            onClick={onClose}
            aria-label="Close"
            className="absolute top-6 right-4 z-10 hover:opacity-80 transition-opacity"
          >
            <CloseCircleGreyIcon className="w-8 h-8" />
          </button>

          <div className="p-8 pt-10">
            {/* Header */}
            <div className="text-center mb-6">
              <p className="text-[#344054] font-semibold text-lg mb-2">Your Credit balance:</p>
              <h2 className="text-6xl font-bold text-[#012169]">{creditBalance.toLocaleString()}</h2>
            </div>

            {/* Warning Card */}
            <div className="bg-[#FFF5E6] rounded-xl p-4 mb-8 flex items-start gap-3">
              <div className="flex-shrink-0 mt-0.5">
                <Warning2Icon className="w-5 h-5" />
              </div>
              <p className="text-[#475467]">
                {description ??
                  (creditsRequired !== undefined ? (
                    <>
                      This action needs{" "}
                      <span className="font-bold text-[#1D2939]">{creditsRequired.toLocaleString()}</span> credits.
                      Top up to continue.
                    </>
                  ) : (
                    <>
                      Each CV requires <span className="font-bold text-[#1D2939]">{creditsPerCV}</span> credits. Your
                      remaining balance may not be enough to analyze multiple CVs.
                    </>
                  ))}
              </p>
            </div>

            <button
              onClick={onTopupCredit}
              className="w-full py-4 rounded-lg font-medium bg-[#012169] text-white hover:bg-[#011557] transition-colors"
            >
              Topup Credit
            </button>
          </div>
        </div>
      </div>
    </ModalPortal>
  );
};

export { ShortOnCreditModal };
